// Generated by scripts/update_draw_content_options.py. Do not edit by hand.
export const CONTENT_SHOWN_OPTIONS = [
  "Acorn",
  "Anime Boss",
  "Anime Boy",
  "Anime Boy Boss",
  "Anime Cat",
  "Anime Chibi Fire Boy",
  "Anime Cool Boy",
  "Anime Eyes Boy",
  "Anime Furious Girl",
  "Anime Girl",
  "Anime Gymnast Girl",
  "Anime Kid",
  "Anime Laughing Boy",
  "Anime Panicked Girl",
  "Anime Profile",
  "Anime Surprised Girl",
  "Anime Teen",
  "Aquarius",
  "Artichoke",
  "Astro Cat",
  "Avocado",
  "Axolotl",
  "Baby Boar",
  "Baby Elephant",
  "Baby Gator",
  "Baby Kitten",
  "Baby Koala",
  "Baby Monkey",
  "Baby Penguin",
  "Baby Raccoon",
  "Baby Seal",
  "Badger",
  "Banana Tree",
  "Bandit Raccoon",
  "Barn",
  "Beach Ball",
  "Beagle Puppy",
  "Bear",
  "Bear Cub",
  "Berries",
  "Better Circle",
  "Bird",
  "Birthday Cake",
  "Birthday Sheep",
  "Black Bear Cub",
  "Blowfish",
  "Bridge",
  "Bumblebee",
  "Bunny",
  "Butterfly",
  "Cabin",
  "Cabin in the Woods",
  "Cactus",
  "Cactus With Eyes",
  "Camp Fire",
  "Canoe",
  "Capricorn",
  "Capybara",
  "Carrot",
  "Cartoon Eyes",
  "Cat",
  "Cats",
  "Cats Paw",
  "Caveman",
  "Chameleon",
  "Cheeky Monkey",
  "Cheetah",
  "Chef Pig",
  "Cherries",
  "Chibi Warrior Girl",
  "Chickadee",
  "Chipmunk",
  "Chocolate",
  "Christmas Ornament",
  "Church",
  "Clouds",
  "Clown Fish",
  "Cornucopia",
  "Countryside",
  "Cowardly Lion",
  "Cozy Penguin",
  "Crab",
  "Crate of Apples",
  "Cupcake",
  "Cupid",
  "Cute Avocado",
  "Cute Backpack",
  "Cute Banana",
  "Cute Birthday Cake",
  "Cute Burger",
  "Cute Camera",
  "Cute Coffee Cup",
  "Cute Dizzy Clock",
  "Cute Dragon",
  "Cute Fish In a Bowl",
  "Cute Ice Cream",
  "Cute Lightbulb",
  "Cute Milkshake",
  "Cute Night Lamp",
  "Cute Palette",
  "Cute Pigtails Girl",
  "Cute Pillow",
  "Cute Pizza",
  "Cute Popcorn",
  "Cute Potion",
  "Cute Radio",
  "Cute Rocket",
  "Cute Trolley",
  "Cute UFO",
  "Cute Umbrella",
  "Cypress Tree",
  "Daisy",
  "Dalmatian Dog",
  "Daria",
  "Dave",
  "Deer",
  "Desert",
  "Desert View",
  "Diplodocus",
  "DJ Hamster",
  "Dog",
  "Dolphin",
  "Dorothy",
  "Dragon",
  "Dreamy Eyed Girl",
  "Duck",
  "Duckling",
  "Dung Beetle",
  "Easter Bunny",
  "Easter Eggs",
  "Electric Eel",
  "Elephant",
  "Elephants",
  "Elf",
  "Excalibur",
  "Farmer Bear",
  "Fawn",
  "Feather",
  "Fennec Fox",
  "Ferret",
  "Fir Tree",
  "Fire Horse",
  "Fish",
  "Flowers",
  "Fluffy Bunny",
  "Football Dog",
  "Forest Fairy",
  "Fox",
  "Frankenstein",
  "Friendly Ghost",
  "Friends",
  "Frog",
  "Gecko",
  "George",
  "Gingerbread Tree",
  "Giraffe",
  "Golden Puppy",
  "Gorilla",
  "Hairdresser Sheep",
  "Hamster",
  "Happy Clouds",
  "Happy Popsicle",
  "Hay Bale",
  "Hedgehog",
  "Hibiscus",
  "Hip Hop Hippo",
  "Hippo",
  "Holiday Reindeer",
  "Horse",
  "Ice Cream",
  "Jack Russell",
  "Jellyfish",
  "Jenn",
  "Karate Tiger",
  "Kawaii Boy",
  "Kingfisher",
  "Kitten",
  "Kiwi",
  "Koala",
  "Koi Fish",
  "Ladybug",
  "Lamb",
  "Leaf",
  "Lemming",
  "Lemur",
  "Leopard",
  "Lift Me Up",
  "Lighthouse",
  "Line of Trees",
  "Lion",
  "Lotus Bud",
  "Magic of Shading",
  "Manta Ray",
  "Meerkat Pup",
  "Mermaid",
  "Mole in a Hole",
  "Monkey",
  "Monstera",
  "Monsterfy",
  "Moon",
  "Mossy cabin",
  "Mother & Daughter",
  "Mount Fuji",
  "Mountains",
  "Mouse",
  "Movement",
  "Movement Lines",
  "Mushroom",
  "Nest",
  "Olive Branch",
  "Otter",
  "Otters",
  "Owl",
  "Panda",
  "Pansy",
  "Peacock",
  "Peanut",
  "Pear",
  "Phoebe the Poodle",
  "Pig Head",
  "Piglet",
  "Pigtails Girl",
  "Pirate",
  "Polar Bear",
  "Polar Bears",
  "Pomegranate",
  "Pomeranian",
  "Pop Star",
  "Poppy",
  "Poses",
  "Posh Bear",
  "Princess Doll",
  "Proportions",
  "Pumpkin",
  "Pumpkins",
  "Purple Flower",
  "Rabbit",
  "Raccoon",
  "Raven",
  "Red Panda",
  "Reflections",
  "Rhino",
  "Rooster",
  "Sailboat",
  "Santa",
  "Scarecrow",
  "Scary Pumpkin",
  "School Boy In Love",
  "Sea Turtle",
  "Seahorse",
  "Seal",
  "Seashell",
  "Shark",
  "Sheriff Hamster",
  "Shiba with Balloons",
  "Shiny Bubbles",
  "Shiny Fish",
  "Shiny Frog",
  "Shiny Nose Dog",
  "Sleigh",
  "Sloth",
  "Snail",
  "Snail In The Rain",
  "Snake",
  "Snorkeling Dolphin",
  "Snowman",
  "Squirrel",
  "Stone Bridge",
  "Stork",
  "Strawberry",
  "Strawberry With Eyes",
  "Summer Monster",
  "Sunny Pineapple",
  "Super Happy Girl",
  "Swan",
  "Taco With Eyes",
  "Tennis Mouse",
  "Tiger",
  "TinMan",
  "Toast",
  "Toaster",
  "Tom",
  "Tom's Calculator",
  "Tom's Dad",
  "Toucan",
  "Treasure Chest",
  "Tree and river",
  "Triceratops",
  "Trojan Helmet",
  "Tropical Fish",
  "Tulip",
  "Turkey Card",
  "Turtle",
  "Unicorn",
  "Valentines Bear",
  "Vampire",
  "Watering Can (2-Tone)",
  "Watering Can (Hatching)",
  "Watermelon",
  "Whale",
  "Wiener Dog",
  "Winter Tree",
  "Wise Oracle"
] as const;
